export enum TASK_STATUS_UUID {
	'098c14db-3ca5-4c7b-9d3a-556c1f02e1b9' = 'To Do',
	'a35b1fc4-6edd-42a7-a41a-0145d1dc3bde' = 'In Progress',
	'1a9b673e-ef5c-4666-a091-84e6d75e638d' = 'Done',
	'8b44dfa0-cbb8-4a2b-ad48-146f97c5555f' = 'Cancelled',
}

export const TASK_STATUS_UUID_MAP = {
	TO_DO: '098c14db-3ca5-4c7b-9d3a-556c1f02e1b9',
	IN_PROGRESS: 'a35b1fc4-6edd-42a7-a41a-0145d1dc3bde',
	DONE: '1a9b673e-ef5c-4666-a091-84e6d75e638d',
	CANCELLED: '8b44dfa0-cbb8-4a2b-ad48-146f97c5555f',
};
